import React from "react";
import { Text, Flex } from "../../../resourses/digitallabs/one-x-ui";
import "../../../styles/DynamicFormRenderer_Helix.css";
import { MAIN_STEPS } from "../../../constants/constants";

const DynamicLabel = ({ field, fieldRefs, value, isMain, maxLength, renderLabelWithPrefix, step }) => {
  const fieldName = field.name;
  const fieldQuestion = field.question;
  const component = field.component;

  return (
    <Flex key={fieldName} direction="row" align="center" gap="8px" className="dfh-field-wrapper" ref={(el) => (fieldRefs.current[fieldName] = el)}>
      {component === "label" ? (
        <>
          {field.prefix_icon && <img src={`/${field.prefix_icon}`} alt="" height={24} />}

          {/* Label text */}
          <Text
            style={{
              fontSize: "14px",
              fontWeight: 600,
              color: "#0C111D",
            }}
          >
            {fieldQuestion}
          </Text>
        </>
      ) : component === "label_with_bullet" ? (
        <>
          <Text className={isMain ? (step === MAIN_STEPS.PERSONAL_DETAILS ? "dfh-label-small" : "dfh-label") : "subquestion-label"}>
            {renderLabelWithPrefix(isMain, field.question)}
          </Text>
        </>
      ) : null}
      {/* Prefix icon */}
    </Flex>
  );
};

export default DynamicLabel;
